<template>
    <v-container fluid>
          <v-row justify="end">
            <v-col>
              <h1>{{$t("invoicing.verifone.title")}}</h1>
            </v-col>
              <v-col cols="auto">
                  <v-btn
                    class="ma-2"
                    color="primary"
                    @click="navigate()">
                      {{$t("invoicing.transportEvents")}}
                  </v-btn>
              </v-col>
          </v-row>
          <MissingVerifoneEventsTable></MissingVerifoneEventsTable>
    </v-container>
  </template>

<script>
import MissingVerifoneEventsTable from "../components/Invoicing/MissingVerifoneEventsTable";
export default {
    components: { MissingVerifoneEventsTable },
    methods: {
        navigate() {
            this.$router.push({ name: "Invoicing" });
        }
    }
};
</script>

  <style scoped>
  h1 {
      margin-bottom: 1rem;
  }
  </style>
